import React from 'react'
import { Link, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import webLogin from '../../types/webLogin';
function UserSideBarComponent(props: any) {
    const navigate = useNavigate();
    return (
        <section className='flex flex-col text-white' >
            <div className='bg-dsgray user-home-navbar-effects min-h-[56px] xl:min-h-[75px] xl:max-h-[75px]'>
                <div className='' style={{ textDecoration: 'none' }}>
                    <a href={'/'} className='contents w-fit' style={{ textDecoration: 'none' }}>
                        <div className='self-center pt-2 text-4xl py-0 font-bold text-dsBlue font-Roboto text-center flex items-center justify-center'>
                            <img src="assets/img/logoIcono.png" style={{ height: '32px', width: 'auto' }} alt="" />
                            <p className='p-0 m-0 uppercase'>Autoneg</p> 
                            <span className='font-Roboto self-end text-red-700 text-sm'>&nbsp;3.0</span>
                        </div>
                    </a>
                    <div className='self-center text-xl py-0 font-bold text-green-800 font-Roboto text-center mb-2'>Facturacion <span className='text-text-green-800'>Electronica</span></div>
                </div>
            </div>
            {
                props.loginContext.administrator !== "1" && props.loginContext.administrator !== "2" 
                &&
                <div className='items-center'>
                    <i className="pi pi-spin pi-spinner"></i> Cargando...
                </div>
            }
            {
            props.loginContext.administrator === "0" &&
            <div className='px-6'>
                {/* grupo */}
                <div className='font-bold mb-0 mt-4 flex items-center text-base 2xl:text-base'>
                    Comprobantes
                </div>
                <div>
                    <ul className='mt-2 pl-0 space-y-4' style={{textDecoration: 'none', listStyle: 'none'}}>
                        <li>
                            <Link to={'/resumen'} className='text-white flex items-center text-sm 2xl:text-base ds-link-default ds-link-fit-content'><i className="material-icons-outlined md-18 ">dashboard</i>&nbsp; Resumen</Link>
                        </li>
                        <li>
                            <Link to={'/emitidos'} className='text-white flex items-center text-sm 2xl:text-base ds-link-default ds-link-fit-content'><i className="material-icons-outlined md-18 ">call_made</i>&nbsp; Emitidos</Link>
                        </li>
                        <li>
                            <Link to={'/recibidos'} className='text-white flex items-center text-sm 2xl:text-base ds-link-default ds-link-fit-content'><i className="material-icons-outlined md-18 ">call_received</i>&nbsp; Recibidos</Link>
                        </li>
                        <li>
                            <Link to={'/aprobacion'} className='text-white flex items-center text-sm 2xl:text-base ds-link-default ds-link-fit-content'><i className="material-icons-outlined md-18 ">check</i>&nbsp; Aprobacion</Link>
                        </li>
                    </ul>
                </div>
            </div>
            }
            {
            props.loginContext.administrator === "1" &&
            <div className='px-6'>
                {/* grupo */}
                <div className='font-bold mb-0 flex items-center text-base 2xl:text-base mt-2'>
                    Soporte
                </div>
                <div>
                    <ul className='mt-2 pl-0 space-y-4' style={{textDecoration: 'none', listStyle: 'none'}}>
                        <li>
                            <Link to={'/clientes'} className='text-white flex items-center text-sm 2xl:text-base' style={{ textDecoration: 'none' }}><i className="material-icons-outlined md-18 ">list</i>&nbsp; Clientes</Link>
                        </li>
                        <li>
                            <Link to={'/certificates'} className='text-white flex items-center text-sm 2xl:text-base' style={{ textDecoration: 'none' }}><i className="material-icons-outlined md-18 ">admin_panel_settings</i>&nbsp; Certificados</Link>
                        </li>
                        {/* <li>
                            <Link to={'/autorizacion'} className='text-white flex items-center text-sm 2xl:text-base' style={{ textDecoration: 'none' }}><i className="material-icons-outlined md-18 ">verified_user</i>&nbsp; Authorizar Rutas</Link>
                        </li>
                        <li>
                            <Link to={'/enviardata'} className='text-white flex items-center text-sm 2xl:text-base' style={{ textDecoration: 'none' }}><i className="material-icons-outlined md-18 ">forward_to_inbox</i>&nbsp; Enviar Uso</Link>
                        </li> */}
                    </ul>
                </div>
            </div>
            }
            {
            props.loginContext.administrator === "0" &&
            <div className='px-6'>
                {/* grupo */}
                <div className='font-bold mb-0 flex items-center text-base 2xl:text-base mt-2'>
                    Usuario
                </div>
                <div>
                    <ul className='mt-2 pl-0 space-y-4' style={{textDecoration: 'none', listStyle: 'none'}}>
                        {/* <li>
                            <Link to={'/perfil'} className='text-white flex items-center text-sm 2xl:text-base' style={{ textDecoration: 'none' }}><i className="material-icons-outlined md-18 ">person</i>&nbsp; Perfil</Link>
                        </li> */}
                        <li>
                            <Link to={'/configuracion'} className='text-white flex items-center text-sm 2xl:text-base' style={{ textDecoration: 'none' }}><i className="material-icons-outlined md-18 ">manage_accounts</i>&nbsp; Configuracion</Link>
                        </li>
                    </ul>
                </div>
            </div>
            }
            {/* footer */}
            <div className='mt-10  w-full text-[#d0d0d0] pt-2 pb-6'>
                <div className="flex flex-col align-items-center gap-2 items-center">
                    {/* <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png" shape="circle" /> */}
                    <span className="font-bold">{props.userName}</span>
                    <Link onClick={cerrarSesion} to={''} style={{ textDecoration: 'none' }} ><span className="font-bold text-red-500 items-center flex"><i className="material-icons-outlined md-18">logout</i>&nbsp;Cerrar Sesi&oacute;n</span></Link>
                </div>
            </div>
        </section>
    )

    function cerrarSesion() {
        localStorage.removeItem('token');
        localStorage.removeItem('company');
        navigate('/login');
    }
}

UserSideBarComponent.propTypes = {
  userName: PropTypes.string.isRequired,
  loginContext: PropTypes.any.isRequired
};

export default UserSideBarComponent;